import React from 'react';
import PropTypes from 'prop-types';
import { BootstrapModal } from 'shared-components/modal/bootstrap-modal';
import { FormattedMessage } from 'react-intl';

const ContinueModal = ({
  isEdit,
  ...props
}) => {
  return (
    <BootstrapModal
      {...props}
      header={
        <div>
          <i className="ico ico-2x icon-confirmed-check text-green margin-lg-bottom" />
          <h3>
            <FormattedMessage id="hosting.continue_modal.hours_saved_message" defaultMessage="Your bookable hours have successfully been saved"/>
          </h3>
          <div className="margin-xl-right margin-xl-left margin-lg-top">
            <FormattedMessage id="hosting.continue_modal.edit_hours_message" defaultMessage="You can edit your bookable hours at any time from your calendar page."/>
          </div>
        </div>
      }
      modalSize="sm-size"
      modalClass="delete-listing-modal"
      body={
        <div className="text-center margin-xl-bottom">
          <div>
            <a
              href="/calendar"
              className="btn btn-block btn-primary"
            >
              <FormattedMessage id="hosting.continue_modal.go_to_calendar_link_text" defaultMessage="Go to Calendar"/>
            </a>
          </div>
        </div>
      }
    />
  );
};

ContinueModal.propTypes = {
  isEdit: PropTypes.bool,
  toggleModal: PropTypes.func,
  spaceId: PropTypes.string
};

export default ContinueModal;
